import {
  GET_SELECTED_MERCHANT_OR_PRODCUCT,
  GET_CART_SELECT_MERCHATS_ZONE,
  GET_SET_STORED_DATA,
  GET_ADDON_UOM,
  GET_CART,
} from "../../database/get-stored-data";
import {
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_SHEDULEDateNTime,
  STORE_CartCheckoutData,
  STORE_MERCHANT_SCROLL,
  STORE_DineType,
  STORE_Addons,
  STORE_Cart,
} from "../../database/store-names";
import {
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  HEADER_TAB_SETUP,
  GET_CART_COUNT,
  KEY_GENERATOR,
} from "../../functions/funtion";
import {
  SET_STORE_CART_SELECT_MERCHATS_ZONE,
  SET_STORE_ADDONUOM,
  SET_STORE_CART,
} from "../../database/store-data";
import {
  PT_PRODUCT_LIST,
  PT_PRODUCT,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../classes/dto-selected-merchant-or-product";
import { api_LoadRecomendedProductsForSelectedItem } from "../../connection/api/api-Machine-Learning";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { api_DaitonnAnalytical } from "../../connection/api/api-Machine-Learning";
import { api_LoadProductToPID } from "../../connection/api/api-product";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { F_Fammily, Font } from "../../util/config-fonts";
import { dto_common } from "../../classes/dto-common";
import { isMobile } from "react-device-detect";
import { PT_CART } from "../../routes/stack/paths/pt-cart";
import { Colors } from "../../util/colors";
import PgProductDescNGDesc from "./components/pg-product/pg-product-description-genaraldescription";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import RecommendedItems from "../../components/render-drawer-recomended-items/render-drawer-recomended-items";
import PgProductAddons from "./components/pg-product/pg-product-addons";
import PgProductPrice from "./components/pg-product/pg-product-price";
import PgProductImage from "./components/pg-product/pg-product-image";
import PgProductNote from "./components/pg-product/pg-product-note";
import PgProductUom from "./components/pg-product/pg-product-uom";
import QtyPlysMinus from "./components/pg-product/pg-product-qty";
import Alert from "../../components/Alert";
import React from "react";
import "../../styles/css/pg-product.css";
import { ToastMessage } from "../../components/toast-notification/toast";

export default class Product extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      IsLoading: true,
      PID: 0,
      LineID: 0,
      AddonLineID: 0,
      Category: 0,
      FromPage: "",
      NavigatePage: "",
      ProductAddOnList: [],
      ProductHandlingCostList: [],
      Product: [],
      ProductImageUrl: "",
      ProductUOMList: [],
      AddonSelectedGUID: [],
      ProductDesc: "",
      Note: "",
      AddOnDesc: "",
      AddonPIDUseqID: "",
      ClearAddonsTrue: "NO",
      DetailProdutUP: 0,
      Qty: 1,
      HandlingCost: 0,
      Total: 0,
      DisplayGrantTotal: 0,
      selectedUomRadioButton: 0,
      MaxAddOnSelection: 0,
      UomSelectedUseqID: 0,
      FillteredProductAddonList: [],
      disabled: false,
      CartItemList: [],
      RecomendedItemDrawer: false,
      RecommendedDataList: [],
      isReacomended: 0,
      goto: null,
      SelectedNuberArray: [],
    };
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    ENCRYPT_STORAGE.removeItem(STORE_MERCHANT_SCROLL);

    this.setState(
      {
        PID: this.props.params.pid,
        LineID: this.props.params.lineid,
        AddonLineID: this.props.params.adonlineid,
        Category: this.props.params.category,
        FromPage: this.props.params.frompage,
        NavigatePage: this.props.params.navigatepage,
        isReacomended: this.props.params.isrecommended,
      },
      async () => {
        await this.LoadProduct();
      },
    );

    await api_DaitonnAnalytical();

    await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
      this.setState({ RecomendedItemDrawer: false });
      await this.PathDivert();
    });
  }

  async LoadProduct() {
    try {
      this.setState({ IsLoading: true });
      let MID = dto_selected_merchant_or_product.MID;
      if (MID === undefined && CSP === "MK") {
        MID = 6;
        dto_selected_merchant_or_product.MID = MID;
      }

      if (this.state.FromPage.toUpperCase() === "CART") {
        MID = dto_selected_final_merchant_or_product.MID;
      }
      let data = await api_LoadProductToPID(MID, this.state.PID);
      let objData = JSON.parse(data);

      await this.SetLineIdNAddOnLineId();
      // let HandlingCost = await this.DataHandlingCost(
      //   objData.dtoProductHandlingCostList
      // );
      this.setState(
        {
          ProductAddOnList: objData.dtoProductAddOnList,
          // ProductHandlingCostList: HandlingCost.HandlingCostarray,
          Product: objData.dtoProductSessionList[0],
          ProductImageUrl: objData.dtoProductSessionList[0].IU.split("λ")[0],
          ProductUOMList: objData.dtoProductUOMList,
          IsLoading: false,
          DetailProdutUP: objData.dtoProductSessionList[0].P,
          ProductDesc: objData.dtoProductSessionList[0].D,
        },
        async () => {
          await this.calculation();
          await HEADER_TAB_SETUP({
            HeaderTabName: CONCAT_TEXT_LIMIT({
              length: 20,
              string: this.state.ProductDesc,
            }),
            FnGoBackScreen: async () => {
              await this.PathDivert();
            },
            HeaderNavigatorMenuDisplay: false,
            FnHeaderNavigatorMenu: () => {},
          });
          await this.AddonUom(
            objData.dtoProductSessionList[0],
            objData.dtoProductAddOnList,
            objData.dtoProductUOMList,
          );
          this.SetModificationAndQtyFromStorageCart(
            objData.dtoProductSessionList[0],
          );
        },
      );
    } catch (error) {
      console.error("LoadProduct : ", error);
    }
  }

  async SetModificationAndQtyFromStorageCart(objectProduct) {
    let Cart = await GET_CART();
    if (Cart !== undefined) {
      if (Cart.length > 0) {
        for (var i = 0; i < Cart.length; i++) {
          if (Cart[i].MID === objectProduct.MID) {
            if (parseInt(Cart[i].LineID) === parseInt(this.state.LineID)) {
              var dataNote = Cart[i].Modification.substring(
                Cart[i].Modification.lastIndexOf("µµ") + 2,
                Cart[i].Modification.lastIndexOf("µ"),
              ).toString();
              if (dataNote === "µ") {
                dataNote = "";
              }
              this.setState(
                {
                  Qty: Cart[i].Qty,
                  Note: dataNote,
                },
                async () => {
                  await this.calculation();
                },
              );

              return;
            }
          }
        }
      }
    }
  }

  async AddonUom(Product, AddonList, UomList) {
    let data = await GET_ADDON_UOM();
    if (data !== undefined) {
      if (this.state.FromPage.toUpperCase() === "CART") {
        var ob = [];
        var useqid = 0;
        if (
          parseInt(Product.MID) ===
          parseInt(dto_selected_final_merchant_or_product.MID)
        ) {
          if (data.length > 0) {
            for (var k = 0; k < data.length; k++) {
              if (
                parseInt(this.state.AddonLineID) === parseInt(data[k].LINEID)
              ) {
                let Qty = data[k].QTY;
                let Description = "";
                for (let i = 0; i < UomList.length; i++) {
                  if (
                    parseInt(data[k].USeqID) === parseInt(UomList[i].USeqID)
                  ) {
                    Product.PI = UomList[i].PID;
                    if (UomList.length > 1) {
                      Description = Product.Description + "-" + UomList[i].UOM;
                    } else {
                      Description = Product.Description;
                    }

                    Product.P = UomList[i].SP;
                    Product.UD = UomList[i].UD;
                    Product.UI = UomList[i].USeqID;
                    useqid = data[k].USeqID;
                    // Product.U = UomList[i].UOM;
                    ob = data[k].ADDONGUID;
                    var objFillteredProductAddonList = [];
                    var listData = this.state.ProductAddOnList;

                    if (ob.length > 0) {
                      var total = 0;
                      objFillteredProductAddonList = [];

                      for (let m = 0; m < listData.length; m++) {
                        var dtoDTOProductAddOnDetailList =
                          listData[m].dtoDTOProductAddOnDetailList;
                        for (
                          let p = 0;
                          p < dtoDTOProductAddOnDetailList.length;
                          p++
                        ) {
                          if (
                            parseInt(data[k].USeqID) ===
                            parseInt(listData[m].USeqID)
                          ) {
                            for (let n = 0; n < ob.length; n++) {
                              if (
                                ob[n] ===
                                dtoDTOProductAddOnDetailList[p].MobileUniqueID
                              ) {
                                listData[m].dtoDTOProductAddOnDetailList[
                                  p
                                ].IsChecked = true;

                                total =
                                  parseFloat(total) +
                                  parseFloat(
                                    listData[m].dtoDTOProductAddOnDetailList[p]
                                      .Price,
                                  );
                                this.setState({
                                  ClearAddonsTrue: "NO",
                                });
                              }
                            }
                          }
                        }
                        objFillteredProductAddonList.push(listData[m]);
                      }
                    }
                    await this.setState(
                      {
                        ProductDesc: Description,
                        DetailProdutUP: UomList[i].SP,
                        Product: Product,
                        Total: total,
                        ProductAddOnList: listData,
                        selectedUomRadioButton: i + 1,
                        ClearAddonsTrue: "NO",
                        FillteredProductAddonList: objFillteredProductAddonList,
                        Qty: Qty,
                        UomSelectedUseqID: useqid,
                        AddonSelectedGUID: ob,
                      },
                      async () => {
                        await this.calculation({ Qty: this.state.Qty });
                      },
                    );
                    break;
                  }
                }
              } else {
                await this.SetAddonUom(Product, AddonList, UomList);
              }
            }
          } else {
            await this.SetAddonUom(Product, AddonList, UomList);
          }
        }
      } else {
        await this.SetAddonUom(Product, AddonList, UomList);
      }
    } else {
      await this.SetAddonUom(Product, AddonList, UomList);
    }
    await this.calculation({ Qty: this.state.Qty });
  }

  async SetAddonUom(Product, AddonList, UomList) {
    let selectedUomRadioButton = 1;
    let Description = "";

    if (AddonList.length > 0) {
      for (let i = 0; i < UomList.length; i++) {
        var useqid = UomList[i].USeqID;
        if (Product.UI === useqid) {
          Product.PID = UomList[i].PID;
          if (UomList.length > 1) {
            Description = Product.D + "-" + UomList[i].UOM;
          } else {
            Description = Product.D;
          }
          let FillteredProductAddonList = [];
          let ProdcutAddonList = this.state.ProductAddOnList;

          for (let j = 0; j < ProdcutAddonList.length; j++) {
            if (ProdcutAddonList[j].USeqID === useqid) {
              FillteredProductAddonList.push(ProdcutAddonList[j]);
            }
          }
          Product.P = UomList[i].SP;
          Product.UD = UomList[i].UD;
          Product.UI = UomList[i].USeqID;
          selectedUomRadioButton = i + 1;
          this.setState({
            MaxAddOnSelection: UomList[i].MaxAddOnSelection,
            UomSelectedUseqID: UomList[i].USeqID,
            ProductDesc: Description,
            selectedUomRadioButton: selectedUomRadioButton,
            FillteredProductAddonList: FillteredProductAddonList,
          });
          break;
        }
      }
    }
  }

  async DataHandlingCost(ProductHandlingCostList) {
    if (ProductHandlingCostList.length === 1) {
      if (ProductHandlingCostList[0].HandlingCost > 0) {
        var newData = [
          [
            {
              IsChecked: false,
              HandlingCost: ProductHandlingCostList[0].HandlingCost,
              PID: ProductHandlingCostList[0].PID,
              USeqID: ProductHandlingCostList[0].USeqID,
            },
          ],
        ];
        return {
          HandlingCostarray: newData,
          HandlingCostDisplay: "flex",
          validateHandlingCost: true,
        };
      } else {
        return {
          HandlingCostarray: ProductHandlingCostList,
          HandlingCostDisplay: "none",
          validateHandlingCost: false,
        };
      }
    } else {
      return {
        HandlingCostarray: ProductHandlingCostList,
        HandlingCostDisplay: "none",
        validateHandlingCost: false,
      };
    }
  }

  async SetModification() {
    if (
      this.state.Note === "" &&
      this.state.AddOnDesc === "" &&
      this.state.AddonPIDUseqID === ""
    ) {
      return "";
    } else {
      return (
        this.state.AddOnDesc +
        "µµ" +
        this.state.Note +
        "µ" +
        this.state.AddonPIDUseqID
      );
    }
  }

  async setIschekedFalseForMainData() {
    var listData = this.state.ProductAddOnList;
    if (listData.length > 0) {
      for (let i = 0; i < listData.length; i++) {
        for (
          let d = 0;
          d < listData[i].dtoDTOProductAddOnDetailList.length;
          d++
        ) {
          if (listData[i].dtoDTOProductAddOnDetailList[d].IsChecked === true) {
            listData[i].dtoDTOProductAddOnDetailList[d].IsChecked = false;
          }
        }
      }
      this.setState({ ProductAddOnList: listData });
    }
  }

  async onChangeQty(type) {
    let cantd = this.state.Qty;
    let MaxQty = this.state.Product.Q;
    if (type) {
      if (MaxQty === 0) {
        cantd = cantd + 1;
        this.setState({ Qty: cantd }, async () => {
          await this.calculation();
        });
      } else {
        if (MaxQty <= cantd) {
          // Alert.MessageBox({
          //   Tittle: "Info",
          //   ConfirmButtonText: "Ok",
          //   Icon: "info",
          //   Text: "Sorry, due to limited stock availability this is the maximum quantity you can purchase at the moment",
          // });

          ToastMessage(
            1,
            "Sorry, due to limited stock availability this is the maximum quantity you can purchase at the moment",
          );

          this.setState({ count: 0 }, async () => {
            await this.calculation();
          });
          return;
        } else {
          cantd = cantd + 1;
          this.setState({ Qty: cantd }, async () => {
            await this.calculation();
          });
        }
      }
    } else if (type === false && cantd >= 2) {
      cantd = cantd - 1;
      this.setState({ Qty: cantd }, async () => {
        await this.calculation();
      });
    } else if (type === false && cantd === 1) {
      this.setState({ Qty: 1 }, async () => {
        await this.calculation();
      });

      // Alert.MessageBox({
      //   Tittle: "Info",
      //   ConfirmButtonText: "Ok",
      //   Icon: "info",
      //   Text: "Invalid quantity",
      // });

      ToastMessage(3, "Invalid quantity");
    }
  }

  async calculation() {
    await this.SetAddonsafterSelectCheckBox();
    var Total = 0;
    var extracost = 0;
    extracost = this.state.Total * this.state.Qty + this.state.HandlingCost;
    Total =
      (this.state.Total +
        this.state.HandlingCost +
        (this.state.DetailProdutUP - this.state.Product.UD)) *
      this.state.Qty;
    this.setState(
      { done: 1, DisplayGrantTotal: Total, Total: extracost },
      async () => {
        await this.DisplayBtnFooterOptions();
      },
    );
  }

  async SetAddonsafterSelectCheckBox() {
    var chkboxes = this.state.FillteredProductAddonList;
    let addonDesc = "";
    let addonPIDUseqIDMake = "";
    var text = "";
    var addonPIDUseqID = "";
    var Total = 0;
    var ADDONGUID = [];
    var SelectedCheckBoxArray = [];

    for (let index = 0; index < chkboxes.length; index++) {
      var data = chkboxes[index].dtoDTOProductAddOnDetailList;
      var SelectedNuber = 0;
      for (let k = 0; k < data.length; k++) {
        if (data[k].IsChecked) {
          text += data[k].AddOnProductDesc + "¥" + this.state.Qty + "|";
          addonPIDUseqID +=
            data[k].AddOnPID +
            "¥" +
            data[k].AddOnUSeqID +
            "¥" +
            this.state.Qty +
            "¥" +
            data[k].Price +
            "|";
          ADDONGUID.push(data[k].MobileUniqueID);
          SelectedNuber = parseInt(SelectedNuber + 1);
          Total = +parseFloat(Total) + parseFloat(data[k].Price);
        }
      }
      var pushSelected = {
        GUID: chkboxes[index].GUID,
        SelectedNuber: SelectedNuber,
      };
      SelectedCheckBoxArray.push(pushSelected);
    }
    if (text.length > 0) {
      addonDesc = text.slice(0, -1);
    } else {
      addonDesc = text;
    }
    if (addonPIDUseqID.length > 0) {
      addonPIDUseqIDMake = addonPIDUseqID.slice(0, -1);
    } else {
      addonPIDUseqIDMake = addonPIDUseqID;
    }
    this.setState({
      done: 0,
      SelectedNuberArray: SelectedCheckBoxArray,
      AddOnDesc: addonDesc,
      AddonPIDUseqID: addonPIDUseqIDMake,
      AddonSelectedGUID: ADDONGUID,
      Total: Total,
    });
  }

  async DisplayBtnFooterOptions() {
    let data = undefined;
    if (this.state.FromPage.toUpperCase() === "CART") {
      data = await GET_CART_SELECT_MERCHATS_ZONE();
    } else {
      data = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
    }
    if (data !== undefined) {
      if (data.IO === false) {
        this.setState({
          disabled: true,
          BtnDisableClr: "red",
          BtnDescription: "MERCHANT CLOSED",
        });
      } else {
        if (this.state.Product.A !== false) {
          this.setState({
            disabled: false,
            BtnDisableClr: Colors.DarkGreyScale, //zeena
            BtnDescription:
              "ADD TO CART" +
              "  -  " +
              dto_StartupPageLoadInfo.Currency +
              " " +
              this.state.DisplayGrantTotal.toFixed(2).replace(
                /(\d)(?=(\d{3})+(?!\d))/g,
                "$1,",
              ),
          });
        } else {
          this.setState({
            disabled: true,
            BtnDisableClr: "#95afc0",
            BtnDescription: "SOLD OUT",
          });
        }
      }
    }
  }

  async SetLineIdNAddOnLineId() {
    if (this.state.FromPage.toUpperCase() !== "CART") {
      let Cart = await GET_CART();
      if (Cart !== undefined) {
        if (Cart.length > 0) {
          if (
            parseInt(dto_selected_merchant_or_product.MID) ===
            parseInt(Cart[0].MID)
          ) {
            this.setState({
              LineID: Cart.length + 1,
              AddonLineID: Cart.length + 1,
            });
          } else {
            this.setState({ LineID: 1, AddonLineID: 1 });
          }
        } else {
          this.setState({ LineID: 1, AddonLineID: 1 });
        }
      } else {
        this.setState({ LineID: 1, AddonLineID: 1 });
      }
    } else {
      this.setState({
        LineID: this.state.LineID,
        AddonLineID: this.state.AddonLineID,
      });
    }
  }

  async validationCheckAddons() {
    var Addons = this.state.FillteredProductAddonList;
    var SelectedNuberArray = this.state.SelectedNuberArray;
    var rtdata = "proceed";

    if (Addons.length !== 0) {
      for (let i = 0; i < Addons.length; i++) {
        if (Addons[i].IsMustSelect !== false) {
          let addonSelected = false;
          let selectedNumber = 0;

          for (let k = 0; k < SelectedNuberArray.length; k++) {
            if (
              SelectedNuberArray[k].GUID === Addons[i].GUID &&
              SelectedNuberArray[k].SelectedNuber > 0
            ) {
              addonSelected = true;
              selectedNumber = SelectedNuberArray[k].SelectedNuber;
              break;
            }
          }

          if (!addonSelected) {
            rtdata = "Please select from " + Addons[i].AddOnDesc;
            return rtdata;
          }

          // Now check Min and Max constraints
          if (
            typeof Addons[i].MinAddOnSelection === "number" &&
            selectedNumber < Addons[i].MinAddOnSelection
          ) {
            rtdata =
              "You must select at least " +
              Addons[i].MinAddOnSelection +
              " from " +
              Addons[i].AddOnDesc;
            return rtdata;
          }

          if (
            typeof Addons[i].MaxAddOnSelection === "number" &&
            selectedNumber > Addons[i].MaxAddOnSelection
          ) {
            rtdata =
              "You can only select up to " +
              Addons[i].MaxAddOnSelection +
              " from " +
              Addons[i].AddOnDesc;
            return rtdata;
          }
        }
      }
      rtdata = "proceed";
    } else {
      rtdata = "proceed";
    }
    return rtdata;
  }

  async setStorageADDONUOM() {
    let ADDONUOM = await GET_ADDON_UOM();
    var ob = [];
    let data = {};
    if (ADDONUOM !== undefined) {
      if (ADDONUOM.length > 0) {
        for (var i = 0; i < ADDONUOM.length; i++) {
          ob = ADDONUOM;
          if (this.state.FromPage.toUpperCase() === "CART") {
            if (parseInt(this.state.LineID) === parseInt(ADDONUOM[i].LINEID)) {
              ob.splice(i, 1);
              data = {
                LINEID: this.state.LineID,
                PID: this.state.PID,
                USeqID: this.state.UomSelectedUseqID,
                ADDONGUID: this.state.AddonSelectedGUID,
                QTY: this.state.Qty,
              };
              ob.push(data);
              await SET_STORE_ADDONUOM(ob);
              return;
            }
          } else {
            data = {
              LINEID: this.state.LineID,
              PID: this.state.PID,
              USeqID: this.state.UomSelectedUseqID,
              ADDONGUID: this.state.AddonSelectedGUID,
              QTY: this.state.Qty,
            };
            ob.push(data);
            await SET_STORE_ADDONUOM(ob);
            return;
          }
        }
      }
    } else {
      data = {
        LINEID: this.state.LineID,
        PID: this.state.PID,
        USeqID: this.state.UomSelectedUseqID,
        ADDONGUID: this.state.AddonSelectedGUID,
        QTY: this.state.Qty,
      };
      ob.push(data);
      await SET_STORE_ADDONUOM(ob);
    }
  }

  async onClickAddCart(data) {
    let addtoproduct = true;
    var da = await this.validationCheckAddons();
    if (da === "proceed") {
      if (this.state.ProductUOMList.length > 1) {
        if (this.state.selectedUomRadioButton === 0) {
          ToastMessage(1, "SELECT OPTIONS");

          return;
        }
      }

      if (addtoproduct === true) {
        let today = new Date();
        let yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);

        let isReacomended = this.state.isReacomended;
        if (isReacomended === undefined) {
          isReacomended = 0;
        }
        this.setState({ CartItemList: [] });
        const ProductInfo = {
          LineID: this.state.LineID,
          PID: data.PI,
          TID: data.TI,
          Code: data.C,
          ProductImageUrl: data.IU,
          Desc: data.D,
          USeqID: data.UI,
          UOM: data.U,
          UP: data.P,
          UD: data.UD,
          Qty: this.state.Qty,
          DecPoint: data.DP,
          Total: 0,
          Modification: await this.SetModification(),
          ExtraCost: this.state.Total,
          DocDiscount: 0,
          VAT: 0,
          TAXID: data.TA,
          MID: data.MID,
          GDescription: data.G,
          IsAvailable: data.A,
          ADDONLINEID: this.state.AddonLineID,
          UDPer: 0,
          IsRecommended: isReacomended,
        };

        let CartList = await GET_CART();

        if (CartList === undefined || CartList.length === 0) {
          await this.CartAddNewItemList(CartList, ProductInfo, 0);
        } else {
          if (CartList.length > 0) {
            for (var i = 0; i < CartList.length; i++) {
              if (parseInt(CartList[i].MID) === parseInt(ProductInfo.MID)) {
                if (
                  parseInt(CartList[i].LineID) ===
                  parseInt(ProductInfo.LineID)
                ) {
                  await this.CartAddNewItemList(CartList, ProductInfo, i);
                  return;
                }
              } else {
                Alert.ConfirmationMessageBox({
                  Tittle: "Change Merchant",
                  Text: "Selecting a different Merchant will clear your current cart. Do you wish to continue?",
                  Icon: "warning",
                  ConfirmButtonText: "Yes",
                  ConfirmButtonFunction: async () => {
                    await this.CartChangeMerchant(CartList, ProductInfo, -1);
                    await SET_STORE_CART_SELECT_MERCHATS_ZONE(
                      dto_selected_merchant_or_product,
                    );
                    ENCRYPT_STORAGE.removeMultipleItems([
                      STORE_SHEDULEDateNTime,
                      STORE_CartCheckoutData,
                      STORE_DineType,
                    ]);
                    dto_cart_checkout.PromoHeader = "";
                    dto_cart_checkout.PromoGuid = 0;
                    dto_cart_checkout.PromoCODE = "";
                    dto_cart_checkout.Comment = "";
                  },
                  DismissButtonFunction: () => {},
                });
                return;
              }
            }
            await this.CartAddNewItemList(CartList, ProductInfo, -1);
          }
        }
      }
    } else {
      ToastMessage(1, da);
      return;
    }
  }

  async CartAddNewItemList(CartList, ProductInfo, i) {
    if (i === 0 && CartList === undefined) {
      CartList = [];
      CartList.push(ProductInfo);
    } else if (i === -1) {
      CartList.push(ProductInfo);
    } else {
      CartList[i] = ProductInfo;
    }
    let cartCOunt = await GET_CART();
    if (cartCOunt === undefined) {
      await SET_STORE_CART_SELECT_MERCHATS_ZONE(
        dto_selected_merchant_or_product,
      );
    }
    await SET_STORE_CART(CartList);
    await this.SetCartLineId();

    await this.setStorageADDONUOM();
    await GET_CART_COUNT();
    await this.NavigateToPageAfterAddtoCartClick();
    return;
  }

  async CartChangeMerchant(CartList, ProductInfo, i) {
    CartList = [];
    ENCRYPT_STORAGE.removeMultipleItems([
      STORE_FinaleSelelctCartMerchantNZone,
      STORE_Addons,
      STORE_Cart,
    ]);
    await this.CartAddNewItemList(CartList, ProductInfo, i);
  }

  async SetCartLineId() {
    let CartItemList = await GET_CART();
    if (CartItemList !== undefined) {
      if (CartItemList.length > 0) {
        for (var i = 0; i < CartItemList.length; i++) {
          CartItemList[i].LineID = i + 1;

          await SET_STORE_CART(CartItemList);
        }
      }
    }
  }

  async NavigateToPageAfterAddtoCartClick() {
    if (this.state.FromPage?.toUpperCase() === "CART") {
      await this.PathDivert();
      return;
    }

    if (dto_StartupPageLoadInfo.IsMLProduct === true) {
      if (CSP === "DT" && dto_selected_merchant_or_product.MID === 6) {
        await this.PathDivert();
      } else {
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        ToastMessage(2, "Item Added");
        await delay(1500);

        this.setState({ IsLoading: true }, async () => {
          if (CSP === "AV" || CSP === "DT") {
            let SelectedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
            dto_common.DineType = SelectedDineType;
          }

          let data = await api_LoadRecomendedProductsForSelectedItem(
            this.state.PID,
          );

          if (data !== "" && data !== undefined && data !== "[]") {
            let da = JSON.parse(data);
            this.setState({
              RecomendedItemDrawer: true,
              RecommendedDataList: da,
              IsLoading: false,
            });
          } else {
            this.setState({
              IsLoading: false,
            });
            await this.PathDivert();
          }
        });
      }
    } else {
      await this.PathDivert();
    }
  }

  async PathDivert() {
    if (this.state.FromPage?.toUpperCase() === "CART") {
      this.props.navigate(PT_CART);
      return;
    }

    if (this.state.NavigatePage === "home") {
      this.props.navigate(PT_HOME);
    } else if (this.state.NavigatePage === "home-filter") {
      this.props.navigate("/home/filter");
    } else {
      this.props.navigate("/" + this.state.NavigatePage);
      if (this.state.FromPage.toUpperCase() === "CATE") {
        this.props.navigate("MasterCategorypage");
      } else {
        this.props.navigate(
          PT_PRODUCT_LIST.replace(
            ":navPage",
            this.state.NavigatePage === "home-filter"
              ? this.state.NavigatePage
              : "none",
          ).replace(":isSec", "false"),
        );
      }
    }
  }

  SelectAddonCheckbox(item, data) {
    let changedCheckbox = item.dtoDTOProductAddOnDetailList.find(
      (cb) => cb.AddOnUSeqID === data.AddOnUSeqID,
    );
    changedCheckbox.IsChecked = !changedCheckbox.IsChecked;
    var chkboxes = item.dtoDTOProductAddOnDetailList;
    var j = 1;
    for (let index = 0; index < chkboxes.length; index++) {
      if (chkboxes[index].IsChecked) {
        if (item.MaxAddOnSelection !== 0) {
          if (item.MaxAddOnSelection < j) {
            changedCheckbox.IsChecked = false;
            j = j - 1;

            // Alert.MessageBox({
            //   Tittle: "Info",
            //   ConfirmButtonText: "Ok",
            //   Icon: "info",
            //   Text:
            //     "Can select only " +
            //     item.MaxAddOnSelection +
            //     " from " +
            //     item.AddOnDesc +
            //     ".",
            // });

            ToastMessage(
              1,
              "Can select only " +
                item.MaxAddOnSelection +
                " from " +
                item.AddOnDesc +
                ".",
            );

            break;
          }
        }
        j++;
      }
    }
    // FillteredProductAddonList.push(item);
    // this.setState({ FillteredProductAddonList: FillteredProductAddonList });
    this.calculation();
  }

  onNoteChange(value) {
    // code to remove non-numeric characters from text
    if (value.indexOf("\n") === -1) {
    } else {
      return;
    }
    if (value === "") {
      this.setState({
        Note: "",
      });
    } else {
      this.setState({
        Note: value,
      });
    }
  }

  ClickUOMRadioButton = async (e, rs, i) => {
    var value = this.state.ClearAddonsTrue;
    let Product = this.state.Product;
    let UP = 0;
    let ProductDescription = "";
    if (value === "YES") {
      await this.setIschekedFalseForMainData();
    }

    Product.PID = rs.PID;
    Product.P = rs.SP;
    Product.UD = rs.UD;
    Product.UI = rs.USeqID;
    UP = rs.SP;
    // Product.U = rs.UOM;

    if (this.state.ProductUOMList.length > 1) {
      ProductDescription = Product.D + "-" + rs.UOM;
    }
    // let HcosT = [];
    // let HcosTData = this.state.HandlingCost;
    let FillteredProductAddonList = [];
    let ProdcutAddonList = this.state.ProductAddOnList;

    for (let j = 0; j < ProdcutAddonList.length; j++) {
      if (ProdcutAddonList[j].USeqID === rs.USeqID) {
        FillteredProductAddonList.push(ProdcutAddonList[j]);
      }
    }

    this.setState(
      {
        MaxAddOnSelection: rs.MA,
        UomSelectedUseqID: rs.USeqID,
        Product: Product,
        FillteredProductAddonList: FillteredProductAddonList,
        selectedUomRadioButton: i + 1,
        ProductDesc: ProductDescription,
        DetailProdutUP: UP,
        ClearAddonsTrue: "YES",
        Total: 0,
      },
      async () => {
        await this.calculation();
      },
    );
  };

  render() {
    return (
      <div
        style={{
          height: "100vh",
          paddingTop: "30px",
        }}
      >
        {this.state.IsLoading ? (
          <div
            className="loader"
            style={{ marginTop: "90%", marginLeft: "45%" }}
          />
        ) : (
          <div
            style={{
              margin: "10px 10px 10px 10px",
              backgroundColor: "white",
              padding: "45px 10px 10px 10px",
              boxShadow:
                CSP === "DT" || CSP === "MK"
                  ? "0px 4px 10px rgba(0, 0, 0, 0.3)"
                  : "",
            }}
            className="fadeInUp animated"
            data-wow-duration="300ms"
            data-wow-delay="0ms"
          >
            <PgProductImage
              imageUrl={this.state.ProductImageUrl}
              key={(e) => {
                KEY_GENERATOR();
              }}
            />

            <PgProductDescNGDesc
              IsAvailable={this.state.Product.A}
              Desc={this.state.ProductDesc}
              GDesc={this.state.Product.G}
              key={KEY_GENERATOR()}
            />

            <PgProductPrice
              SP={this.state.DetailProdutUP}
              UD={this.state.Product.UD}
              key={KEY_GENERATOR()}
            />

            <PgProductUom
              data={this.state.ProductUOMList}
              Heading={"SELECT OPTIONS"}
              SectedButton={this.state.selectedUomRadioButton}
              OnClick={(e, rs, i) => {
                this.ClickUOMRadioButton(e, rs, i);
              }}
            />

            <PgProductAddons
              data={this.state.FillteredProductAddonList}
              OnClick={(e, item, rs, i) => {
                this.SelectAddonCheckbox(item, rs);
              }}
            />

            <PgProductNote
              txt={this.state.Note}
              onNoteChanged={(vl) => {
                this.onNoteChange(vl);
              }}
            />

            <QtyPlysMinus
              Qty={this.state.Qty}
              PlusPress={() => {
                this.onChangeQty(true);
              }}
              MinusPress={() => {
                this.onChangeQty(false);
              }}
              disabled={this.state.disabled}
            />

            <button
              className="pgProductAddCartBtn"
              style={{
                fontSize: Font.MainHeading,
                color: Colors.FontColor,
                backgroundColor: this.state.BtnDisableClr,
                fontFamily: F_Fammily.Medium,
                width: "100%",
                marginLeft: "0%",
              }}
              disabled={this.state.disabled}
              onClick={() => this.onClickAddCart(this.state.Product)}
            >
              {this.state.BtnDescription}
            </button>
          </div>
        )}

        <DrawerSheetBottom
          open={this.state.RecomendedItemDrawer}
          closeFunction={() => this.setState({ RecomendedItemDrawer: false })}
          displayCloseIcon="block"
          element={
            <>
              {this.state.RecommendedDataList.length > 0 ? (
                <RecommendedItems
                  data={this.state.RecommendedDataList}
                  NavigateToProductPage={(e) => {
                    this.props.navigate(
                      PT_PRODUCT.replace(":frompage", "product-list")
                        .replace(":navigatepage", this.state.NavigatePage)
                        .replace(":category", "category")
                        .replace(":pid", e.PI)
                        .replace(":lineid", 1)
                        .replace(":adonlineid", 1)
                        .replace(":isrecommended", 1),
                    );
                    this.setState({
                      RecomendedItemDrawer: false,
                      IsLoading: true,
                    });
                    window.location.reload();
                  }}
                />
              ) : (
                ""
              )}

              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "95%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "20px",
                }}
                onClick={() => this.setState({ RecomendedItemDrawer: false })}
              >
                {" "}
                Dismiss{" "}
              </button>
            </>
          }
          size={isMobile ? "85%" : 280}
          Heading="FREQUENTLY BOUGHT TOGETHER"
        />
      </div>
    );
  }
}
